import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Modal, Button, FormGroup, Dropdown, MenuItem,
  ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { isArray, each, keys, find, sortBy } from 'lodash';

const statusOptions = {
  name: 'status',
  label: 'Status',
  values: [
    { value: '', label: 'All Status' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
  ],
};

const mappingOptions = {
  name: 'mappings',
  label: 'Mappings',
  values: [
    { value: '', label: 'All Mappings' },
    { value: 'assigned', label: 'Assigned' },
    { value: 'excluded', label: 'Excluded' },
  ],
};

const excludeOptions = {
  name: 'exclude',
  label: 'Excluded',
  values: [
    { value: '', label: 'All' },
    { value: 'included', label: 'Included' },
    { value: 'excluded', label: 'Excluded' },
  ],
};

const CheckboxGroup = ({
  label, name, options, compType, input, description,
}) => {
  const sortedOptions = compType === 'boolean' ? options : sortBy(options, o => o.value || '');
  return (
    <FormGroup controlId={name}>
      {label !== null && <ControlLabel>{label}</ControlLabel>}
      {description && <p><small>{description}</small></p>}
      <div style={{ paddingLeft: 20 }}>
        {sortedOptions.map((option, index) => (
          <div className="checkbox" key={index}>
            <label>
              <input
                type="checkbox"
                name={`${name}[${index}]`}
                value={option.value || ''}
                checked={input.value.indexOf(option.value) !== -1}
                onChange={(event) => {
                  const newValue = [...input.value];
                  if (event.target.checked) {
                    newValue.push(option.value);
                  } else {
                    newValue.splice(newValue.indexOf(option.value), 1);
                  }
                  return input.onChange(newValue);
                }}
              />
              &nbsp;
              <span>{option.label}</span>
            </label>
          </div>))}
      </div>
    </FormGroup>
  );
};
CheckboxGroup.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  compType: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  input: PropTypes.object,
};

const RadioGroup = ({
  label, name, options, input,
}) => (
  <FormGroup controlId={name}>
    <ControlLabel>{label}</ControlLabel>
    <div>
      {options.map((option, index) => (
        <div className="radio-inline" key={index}>
          <label>
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={input.value === option.value}
              onChange={(event) => {
                let newValue = null;
                if (event.target.checked) {
                  newValue = option.value;
                }
                return input.onChange(newValue);
              }}
            />
            &nbsp;
            {option.label}
          </label>
        </div>))}
    </div>
  </FormGroup>
);
RadioGroup.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  input: PropTypes.object,
};

class SearchForm extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
      data: {},
      selected: null,
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.reset = this.reset.bind(this);
    this.renderField = this.renderField.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  close() {
    this.props.reset();
    if (this.mounted) {
      this.setState({ showModal: false });
    }
  }

  open() {
    this.props.initialize({ ...this.state.data });
    this.setState({ showModal: true });
  }

  handleSubmit(params) {
    const { showStatus, showMapping, showExclude } = this.props;
    const data = { ...params };
    if (!showStatus) {
      delete data[statusOptions.name];
    }
    if (!showMapping) {
      delete data[mappingOptions.name];
    }
    if (!showExclude) {
      delete data[excludeOptions.name];
    }
    if (!data.searchable || keys(data.searchable) === 0) {
      delete data.searchable;
    }
    this.props.onApply(data);
    this.setState({ data });
    this.close();
  }

  reset() {
    this.handleSubmit({});
    this.props.initialize({});
  }

  renderField({
    input, label, type, disabled, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        <ControlLabel>{label}</ControlLabel>
        <FormControl {...input} placeholder={label} type={type} disabled={submitting || disabled} />
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  renderFilters() {
    const { filters, searchable } = this.props;
    const { selected } = this.state;
    const selectedItem = find(filters, { name: selected });
    if (filters.length === 0) {
      return null;
    }
    const showAll = filters.length < 3;
    let cls = '';
    if (!showAll && selectedItem) {
      cls = 'well well-sm';
    }

    return (
      <div>
        {!showAll && <Dropdown id="searchable">
          <Dropdown.Toggle>
            {selectedItem !== undefined && <span>{selectedItem.label}</span>}
            {selectedItem === undefined && <span>Extra Attributes</span>}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {filters.map(f => (
              <MenuItem
                key={f.name}
                active={selectedItem ? selectedItem.name === f.name : false}
                onClick={() => { this.setState({ selected: f.name }); }}
              >
                {f.label}
                {searchable && searchable[f.name] && searchable[f.name].length > 0 &&
                <span>&nbsp;<span className="badge">{searchable[f.name].length}</span></span>}
              </MenuItem>
              ))}
          </Dropdown.Menu>
        </Dropdown>}
        <div className={cls}>
          {filters.map((f) => {
            if (showAll || (selectedItem && selectedItem.name === f.name)) {
              return (
                <Field
                  key={f.name}
                  compType={f.type}
                  name={`searchable[${f.name}]`}
                  description={f.description}
                  label={showAll ? f.label : null}
                  component={CheckboxGroup}
                  options={f.values}
                />
              );
            }
            return null;
          })}
        </div>
      </div>
    );
  }

  renderModal(count = 0) {
    const {
      handleSubmit, title, showStatus, showMapping, showExclude,
    } = this.props;
    return (
      <Modal show={this.state.showModal} onHide={this.close} keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Body>
            {showStatus && <Field
              name={statusOptions.name}
              label={statusOptions.label}
              component={RadioGroup}
              options={statusOptions.values}
            />}
            {showMapping && <Field
              name={mappingOptions.name}
              label={mappingOptions.label}
              component={RadioGroup}
              options={mappingOptions.values}
            />}
            {showExclude && <Field
              name={excludeOptions.name}
              label={excludeOptions.label}
              component={RadioGroup}
              options={excludeOptions.values}
            />}
            {this.renderFilters()}
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
              <div className="col-sm-4">
                {count > 0 && <div className="pull-left">
                  <Button bsStyle="link" onClick={this.reset}>Reset</Button>
                </div>}
              </div>
              <div className="col-sm-8">
                <Button bsStyle="link" onClick={this.close}>Cancel</Button>
                <Button bsStyle="primary" type="submit">
                  <span><Fa name="check" /> Apply</span>
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  render() {
    const {
      disabled, size, showStatus, showMapping, showExclude,
    } = this.props;
    const { data } = this.state;
    let count = 0;
    if (showStatus && data[statusOptions.name] && data[statusOptions.name] !== '') {
      count += 1;
    }
    if (showMapping && data[mappingOptions.name] && data[mappingOptions.name] !== '') {
      count += 1;
    }
    if (showExclude && data[excludeOptions.name] && data[excludeOptions.name] !== '') {
      count += 1;
    }
    if (data.searchable) {
      each(data.searchable, (f) => {
        if (isArray(f) && f.length > 0) {
          count += 1;
        }
      });
    }
    return (
      <span>
        {this.renderModal(count)}
        <Button disabled={disabled} active={count > 0} bsSize={size} onClick={this.open} bsStyle="default">
          <span><Fa name="filter" /> Advanced Search {count > 0 && <span className="badge">{count}</span>}</span>
        </Button>
      </span>
    );
  }
}

SearchForm.propTypes = {
  initialize: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  reset: PropTypes.func,
  onApply: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
  filters: PropTypes.array.isRequired,
  size: PropTypes.string,
  error: PropTypes.string,
  title: PropTypes.string,
  showStatus: PropTypes.bool,
  showMapping: PropTypes.bool,
  showExclude: PropTypes.bool,
  searchable: PropTypes.object,
};
SearchForm.defaultProps = {
  onApply: () => {},
  disabled: false,
  size: null,
  title: 'Filters',
  showStatus: false,
  showMapping: false,
  showExclude: false,
};

const selector = formValueSelector('mappingSearchForm'); // <-- same as form name

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    searchable: selector(state, 'searchable'),
  };
}

const MappingSearchForm = reduxForm({
  form: 'mappingSearchForm',
})(SearchForm);

export default connect(mapStateToProps)(MappingSearchForm);
